module.exports = __webpack_public_path__ + "src/assets/img/illustrations/aclacka-tasks-in-focus-time.09bd1b65c85cdc28b0ad034b30023cad.png";